import React from 'react';
import { useNavigate } from '@tanstack/react-router';

export default function InvitationScreen() {
  const navigate = useNavigate();
  React.useEffect(() => {
    void navigate({ to: '/login', replace: true });
  }, [navigate]);
  return null;
}
